import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_LIST} from 'vx/mutations'



// Contact state.
const state = {
  projects: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  projects: state => state.projects,

  getById: (state) => (id) => {
    return state.projects.find(project => project.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of projects.
   */
  getList ({ commit }, payload) {
    return http.get(`/projects/list`, {params: payload}).then(response => {
      commit(SET_LIST, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the clients state.
  */
  [SET_LIST] (state, projects) {
    state.projects = projects
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
